export default [
	// 代理商管理——组织管理
	{
		path: "SchoolArchives/CampusList",
		name: "CampusList",
		meta: {
			title: "组织档案",
			keepAlive: true
		},
		component: () =>
			import("@/views/Home/AngentManage/OrganizationManage/index.vue")
	},
	// 代理商管理——组织管理——新增
	{
		path: "SchoolArchives/AddCampus",
		name: "AddCampus",
		meta: {
			title: "新增"
		},
		component: () =>
			import("@/views/Home/AngentManage/OrganizationManage/AddCampus/index.vue")
	},
	// 代理商管理——组织管理——查看详情
	{
		path: "SchoolArchives/CampusDetail",
		name: "CampusDetail",
		meta: {
			title: "查看详情"
		},
		component: () =>
			import("@/views/Home/AngentManage/OrganizationManage/CampusDetail/index.vue")
	},
	// 代理商管理——组织管理——退费
	{
		path: "SchoolArchives/Refund",
		name: "Refund",
		meta: {
			title: "退费"
		},
		component: () =>
			import("@/views/Home/AngentManage/OrganizationManage/Refund/index.vue")
	},
	// 代理商管理——组织管理——片区释放
	{
		path: "SchoolArchives/AreaRelease",
		name: "AreaRelease",
		meta: {
			title: "片区释放"
		},
		component: () =>
			import("@/views/Home/AngentManage/OrganizationManage/AreaRelease/index.vue")
	},
	// 代理商管理——组织管理——校区档案
	{
		path: "SchoolArchives/CollaborativeManagement",
		name: "CollaborativeManagement",
		meta: {
			title: "校区档案"
		},
		component: () =>
			import("@/views/Home/AngentManage/OrganizationManage/model/CollaborativeManagement/index.vue")
	},
	// 代理商管理——组织管理——地图
	{
		path: "SchoolArchives/AMap",
		name: "AMap",
		meta: {
			title: "地图"
		},
		component: () =>
			import("@/views/Home/AngentManage/OrganizationManage/model/CollaborativeManagement/AMap.vue")
	},
	// 代理商管理——广告设置
	{
		path: "SchoolArchives/Advertisement",
		name: "Advertisement",
		meta: {
			title: "广告设置"
		},
		component: () =>
			import("@/views/Home/AngentManage/Advertisement/index.vue")
	},
	{
		path: "CallRecords",
		name: "CallRecords",
		meta: {
			title: "通话记录查询"
		},
		component: () =>
			import("@/views/Home/AngentManage/CallRecords/index.vue")
	},
	{
		path: "CallDuration",
		name: "CallDuration",
		meta: {
			title: "通时通次排行"
		},
		component: () =>
			import("@/views/Home/AngentManage/CallDuration/index.vue")
	},
	{
		path: "AccountSeteatStatus",
		name: "AccountSeteatStatus",
		meta: {
			title: "座席状态监控"
		},
		component: () =>
			import("@/views/Home/AngentManage/AccountSeteatStatus/index.vue")
	},
	{
		path: "SchoolArchives/PublicSchoolManagement",
		name: "PublicSchoolManagement",
		meta: {
			title: "座席状态监控"
		},
		component: () =>
			import("@/views/Home/AngentManage/PublicSchoolManagement/index.vue")
	},
]